import React, { createContext, useContext, useState, useRef } from "react";

export const GuestContext = createContext();

export const GuestProvider = ({ children }) => {
  const [isGuest, setIsGuest] = useState(false);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [showSubscription, setShowSubscription] = useState(false);

  // Timer reference
  const subscriptionTimerRef = useRef(null);

  const startSubscriptionTimer = () => {
    // Clear previous timer if exists
    if (subscriptionTimerRef.current) clearTimeout(subscriptionTimerRef.current);

    // Start new timer for 2 minutes
    subscriptionTimerRef.current = setTimeout(() => {
      setShowSubscription(true);
    }, 120000); // 120000 ms = 2 minutes
  };

  const closeSubscription = () => {
    setShowSubscription(false);
    startSubscriptionTimer(); // restart 2-minute timer
  };

  return (
    <GuestContext.Provider
      value={{
        isGuest,
        setIsGuest,
        isSubscribed,
        setIsSubscribed,
        showSubscription,
        setShowSubscription,
        startSubscriptionTimer,
        closeSubscription,
      }}
    >
      {children}
    </GuestContext.Provider>
  );
};

export const useGuest = () => useContext(GuestContext);
